import * as v from 'valibot';

export const BrandingSchema = v.object({
  isFallbackBranding: v.fallback(v.boolean(), false),
  brandingId: v.nullish(v.number()),
  cpNavColor: v.fallback(v.string(), '#34415A'),
  cpPrimaryColor: v.fallback(v.string(), '#59784B'),
  cpSecondaryColor: v.fallback(v.string(), '#000000'),
  cpLogo: v.fallback(v.string(), ''),
  extradefaultfont: v.fallback(v.string(), ''),
  favicon: v.fallback(v.string(), ''),
  logoUrl: v.fallback(v.string(), ''),
});

export const StrictBrandingSchema = v.object({
  ...BrandingSchema.entries,
  cpNavColor: v.string(),
  cpPrimaryColor: v.string(),
  cpSecondaryColor: v.string(),
});

export type TBranding = v.Output<typeof BrandingSchema>;
